/**
 * Safely retrieves access token from localStorage
 * @returns {string|null} - Access token or null if not found
 */
export const getAccessToken = () => {
  try {
    if (typeof window === 'undefined') {
      console.warn('getAccessToken: window is not defined');
      return null;
    }
    
    const token = localStorage.getItem('accessToken');
    
    if (!token) {
      console.warn('getAccessToken: No access token found in localStorage');
      return null;
    }
    
    if (token === 'undefined' || token === 'null') {
      console.warn('getAccessToken: Invalid token value in localStorage:', token);
      localStorage.removeItem('accessToken'); // Clean up invalid token
      return null;
    }
    
    return token;
  } catch (error) {
    console.error('getAccessToken: Error retrieving access token:', error);
    return null;
  }
};

/**
 * Safely sets access token in localStorage
 * @param {string} token - Access token to store
 */
export const setAccessToken = (token) => {
  try {
    if (typeof window === 'undefined') {
      console.warn('setAccessToken: window is not defined');
      return;
    }
    
    if (!token) {
      console.warn('setAccessToken: No token provided, removing from localStorage');
      localStorage.removeItem('accessToken');
      return;
    }
    
    localStorage.setItem('accessToken', token);
    console.log('setAccessToken: Token stored successfully');
  } catch (error) {
    console.error('setAccessToken: Error storing access token:', error);
  }
};

/**
 * Checks if access token exists and is valid
 * @returns {boolean} - True if token exists and is not undefined/null
 */
export const hasValidAccessToken = () => {
  const token = getAccessToken();
  return token !== null && token !== undefined;
};
